import { Button, Popover } from '@mui/material'
import I18n from 'i18n-js'
import { useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import { CalendarEventType } from './Calendar'
import ShowMorePanel from './ShowMorePanel'

const useStyles = makeStyles()((theme) => ({
  showMoreButton: {
    fontSize: theme.typography.caption.fontSize,
    height: '20px',
    marginTop: theme.spacing(1),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.secondary,
  },
  container: {
    textAlign: 'center',
  },
}))

interface ShowMoreButtonProps {
  date?: Date
  count: number
  events?: CalendarEventType[]
}

const ShowMoreButton: React.FC<
  React.PropsWithChildren<ShowMoreButtonProps>
> = ({ events = [], date, count }) => {
  const { classes } = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  return (
    <div className={classes.container}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {events.length && date && (
          <ShowMorePanel
            events={events}
            date={date}
            onClose={handlePopoverClose}
          />
        )}
      </Popover>
      <Button
        size="small"
        className={classes.showMoreButton}
        onClick={anchorEl ? handlePopoverClose : handlePopoverOpen}
      >
        {I18n.t('calendar.showMore', { count })}
      </Button>
    </div>
  )
}
export default ShowMoreButton
